<template>
  <div id="app" v-wechat-title="$route.meta.title">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: "App"
  };

</script>

<style>
  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width: 100%;
    min-height: 100%;
    background: #f7f7f7;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue